import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { TextPlugin } from 'gsap/TextPlugin';

gsap.registerPlugin(ScrollTrigger, TextPlugin);

const setup = () => {
  const toggles = gsap.utils.toArray('[data-w-value-switch]');

  if (toggles) {
    toggles.forEach((toggle) => {
      const toggleContext = toggle.closest('.w-b-tower-scroll-scene');
      gsap.set(toggleContext, {
        '--_slider-progress': `0%`,
        '--_scroll-color-dark': `color-mix(in srgb, var(--color-green-dark) var(--_slider-progress), var(--color-cool-gray-light) calc(100% - var(--_slider-progress)))`,
        '--_scroll-color': `color-mix(in srgb, var(--color-green) var(--_slider-progress), var(--color-cool-gray) calc(100% - var(--_slider-progress)))`,
        '--_scroll-background-color': `color-mix(in srgb, var(--color-bg-green) var(--_slider-progress), var(--color-bg-blue) calc(100% - var(--_slider-progress)))`,
        '--_scroll-color-outline': `color-mix(in srgb, var(--_scroll-color) 20%, transparent)`,
      });

      const sliderValue = toggle.querySelector('[data-w-value-switch-value]');

      const inputs = toggle.querySelectorAll('input[type="radio"]');
      inputs.forEach((input, index) => {
        input.addEventListener('change', () => {
          const progress = index;
          gsap.to(toggleContext, {
            duration: 0.125,
            ease: 'power2.inOut',
            '--_slider-progress': `${progress * 100}%`,
          });

          const value = input.value;
          gsap.to(sliderValue, {
            duration: 0.25,
            ease: 'power2.inOut',
            text: {
              value: value,
            },
          });
        });
      });
    });
  }
};

export default function ValueSwitch() {
  return {
    init: () => {
      setup();
    },
  };
}
